<template>
<div>
    <div class="logo">
        <img v-if="$i18n.locale == 'se'" src="img/kunniakierros-logo-se.png" />
        <img v-else src="img/kunniakierros-logo-fi.png" />
    </div>
    <div class="error fadeout" v-if="error">{{ error }}</div>

    <form key="username" @submit.prevent="checkUsername" novalidate v-if="state == 'username'">
        <input type="email" v-model="username" autofocus :placeholder="$t('user.username')"/>
        <button v-if="!requestingPin" class="button button-green" type="submit">{{ $t("loginView.askForPin") }}</button>
        <button v-else disabled class="button">{{ $t("loginView.requestingPin") }}</button>
    </form>

    <form key="pin" @submit.prevent="login" novalidate v-else-if="state == 'pin'">
        <input type="number" pattern="[0-9]*" autofocus v-model="pin" :placeholder="$t('user.pin')" />

        <button class="button button-green" type="submit">{{ $t("loginView.login") }}</button>

        <p>{{ $t("loginView.sendPinHelp") }}</p>

        <button class="button" type="button" @click="sendPin">{{ $t("loginView.sendPin") }}</button>
    </form>
</div>
</template>

<script lang="ts">
import axios from "axios";
import { store } from "store";
import { defineComponent } from "vue";

interface AuthenticationResponse {
    status: "Success" | "NonexistentUser" | "PinExists" | "PinExpired" | "PinSent" | "PinInvalid";
    accessToken: string;
}

export default defineComponent({
    mounted() {
        this.setTitle();
    },
    data() {
        return {
            state: "username",
            username: "",
            pin: "",
            error: "",
            pinSentMessageVisible: false,
            requestingPin: false
        };
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("loginView.title") as string;
            store.page.showTopNav = true;
        },
        async checkUsername() {
            this.error = "";
            this.requestingPin = true;

            try {
                let { data } = await axios.post<AuthenticationResponse>(
                    "authentication/login",
                    { username: this.username }
                );

                this.requestingPin = false;

                if (data.status == "NonexistentUser") {
                    this.error = this.$t("loginView.nonexistentUser") as string;
                    return;
                }

                if (data.status == "PinSent") {
                    this.pinSentPopup();
                }

                this.state = "pin";
            } catch(err) {
                this.error = this.$t("loginView.pinRequestFailed") as string;
                this.requestingPin = false;
            }
        },
        async login() {
            this.error = "";

            if (!this.pin) {
                this.error = this.$t("loginView.enterPin") as string;
                return;
            }

            let { data } = await axios.post<AuthenticationResponse>(
                "authentication/login",
                {
                    deviceId: store.identity.deviceId,
                    username: this.username,
                    pin: this.pin
                });

            if (data.status == "NonexistentUser") {
                this.state == "username";
                return;
            }

            if (data.status == "PinInvalid") {
                this.error = this.$t("loginView.pinInvalid") as string;
                return;
            }

            if (data.status == "PinExpired") {
                await this.sendPin();
                return;
            }

            store.identity.accessToken = data.accessToken;
            localStorage.setItem("accessToken", data.accessToken);

            this.$router.replace("/");
        },
        async sendPin() {
            let { data } = await axios.post<AuthenticationResponse>(
                "authentication/sendpin",
                { username: this.username }
            );

            if (data.status == "NonexistentUser") {
                this.error = "User has disappeared. Try again.";
                this.state = "username";
                return;
            }

            this.pinSentPopup();
        },
        pinSentPopup() {
            this.$popup(this.$t("loginView.pinSentTopic") as string, this.$t("loginView.pinSent") as string);
        }
    }
})

</script>